import React from 'react';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';
import { IInvoiceFullObject } from '../../Interfaces/IInvoice';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { InvoiceRow } from './InvoiceRow';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { ILegalRole } from '../../Interfaces/ILegalRole';
import { ILegalTransactionType } from '../../Interfaces/ILegalTransactionType';

interface IProps {
  idLegalTransaction: number;
  downloadedArray?: IDocumentDownloaded[];
  invoiceObjectArray: IInvoiceFullObject[];
  setInvoiceObjectArray: Function;
  //
  legalClients: ILegalClient[];
  setLegalClients: Function;
  legalRoles: ILegalRole[];
  legalTransactionTypes: ILegalTransactionType[];
}

export const InvoiceTable: React.FC<IProps> = ({
  idLegalTransaction,
  downloadedArray,
  invoiceObjectArray,
  setInvoiceObjectArray,
  legalClients,
  setLegalClients,
  legalRoles,
  legalTransactionTypes,
}) => {
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={'5%'}>Nr.</TableCell>
            {downloadedArray && <TableCell width={'5%'}>Runter.</TableCell>}
            <TableCell width={'20%'}>Art</TableCell>
            <TableCell width={'20%'}>Zahlungsschuldner</TableCell>
            <TableCell width={'20%'}>Rechnungssumme</TableCell>
            <TableCell width={'20%'}>Dateiname</TableCell>
            <TableCell width={'35%'}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoiceObjectArray.map(invoice => (
            <InvoiceRow
              key={`invoice-${invoice.idInvoice}`}
              invoiceObject={invoice}
              invoiceObjectArray={invoiceObjectArray}
              setInvoiceObjectArray={setInvoiceObjectArray}
              downloadedArray={downloadedArray}
              legalClients={legalClients}
              legalRoles={legalRoles}
              setLegalClients={setLegalClients}
              legalTransactionTypes={legalTransactionTypes}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
};
